import { computed } from 'vue';
import { useStore } from 'vuex';
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useLastNameKanaField = (required, messages = {}) => {
  const validator = yup
    .string()
    .max(30, messages['max'] || 'せい（ふりがな）は30文字以内にしてください')
    .kanaFormat(
      messages['field'] || 'せい（ふりがな）',
      messages['kanaFormat'] ||
        'せい（ふりがな）はひらがな・カタカナのみ使用できます'
    )
    .requirement(
      required,
      messages['requirement'] || 'せい（ふりがな）は必須項目です'
    );
  const fieldName = computed(() => 'last_name_kana');

  return { validator, fieldName };
};

export const useLastNameKanaStore = () => {
  const store = useStore();
  const lastNameKana = computed(() => store.state.formData.last_name_kana);
  const dispatcher = computed(() => 'formData/setLastNameKana');

  return { lastNameKana, dispatcher };
};
